import { useCallback, useEffect, useState } from 'react';

const KEY = 'storeo-painel-theme';

function systemIsDark(): boolean {
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
}

function apply(theme: 'light' | 'dark' | null): void {
  const root = document.documentElement;
  if (theme) root.setAttribute('data-theme', theme);
  else root.removeAttribute('data-theme');
}

/** Alterna `[data-theme]` (tokens.css já cobre os 3 estados — ver packages/ui/src/tokens.css). */
export function useTheme() {
  const [theme, setTheme] = useState<'light' | 'dark' | null>(() => {
    try {
      return (localStorage.getItem(KEY) as 'light' | 'dark' | null) ?? null;
    } catch {
      return null;
    }
  });

  useEffect(() => apply(theme), [theme]);

  const toggle = useCallback(() => {
    setTheme((cur) => {
      const isDark = cur ? cur === 'dark' : systemIsDark();
      const next = isDark ? 'light' : 'dark';
      try {
        localStorage.setItem(KEY, next);
      } catch {
        /* private mode etc. — a troca ainda funciona pra sessão atual */
      }
      return next;
    });
  }, []);

  return { theme, toggle };
}
